export default "__VITE_ASSET__b4cc5360__"